import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section aria-labelledby="faq-title" className="bg-dusk" data-id="element-77" data-mp="1gd7gc7wyl95h">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-20 lg:grid-cols-[0.8fr_1.2fr] lg:py-24" data-id="element-78" data-mp="1gauq77h1rshc">
        <div data-id="element-79" data-mp="2dy3ipmfgu1su">
          <p className="font-display text-lg font-semibold text-pumpkin" data-id="element-80" data-mp="291mkfzejy721">Dudas comunes</p>
          <h2 id="faq-title" className="mt-3 font-display text-4xl font-bold text-bone sm:text-5xl" data-id="element-81" data-mp="2429ydgvi940i">Preguntas frecuentes</h2>
        </div>

        <ul className="divide-y divide-line border-y border-line" data-id="element-82" data-mp="1z25gpniv238p">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} data-id="element-83" data-mp="no0ccteqjrcu" data-mpi={i}>
                <h3 data-id="element-84" data-mp="nnqqni0q46cy">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left font-bold text-bone transition-colors duration-150 ease-out hover:text-pumpkin-soft focus:outline-none focus-visible:text-pumpkin" data-id="element-85" data-mp="nmgsytxs906u">
                    {f.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-pumpkin transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-86" data-mp="6qeybd6nenrv" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-87" data-mp="1ru01jayie62">
                  {isOpen && <motion.div id={`faq-${i}`} initial={reduce ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={reduce ? {
                opacity: 0
              } : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-88" data-mp="3jy8b9ahuca0r">
                      <p className="pb-5 pr-8 leading-relaxed text-mist" data-id="element-89" data-mp="1krt7g8dqfydn">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}